import React, {useEffect, useState} from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import {useTranslation} from 'react-i18next';
import circleTR from "../../../assets/icons/circleTR.png";
import circleUK from "../../../assets/icons/circleUK.png";
import circleUSA from "../../../assets/Images/usa-flag.png";
import rectUK from "../../../assets/icons/rectUK.png";
import rectTR from "../../../assets/icons/rectTR.png";
import {Fade} from "@material-ui/core";
import clsx from "clsx";
import {ExpandLess, ExpandMore} from "@material-ui/icons";

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
        // left:'73% !important',
    },

})((props) => (
    <Menu
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
));
const useStyles = makeStyles({
    borderRadius: {
        borderRadius: '3px',
    },
    hide: {display: "none"},
    text: {
        marginLeft: '15px',
    },
    menu: {
        paddingTop: '0',
    },
    langMenu: {
        right: '-100px'
    }
});

const StyledMenuItem = withStyles((theme) => ({
    root: {
        '&:hover': {
            backgroundColor: '#001b2e',
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
            },
        },
    },
}))(MenuItem);

export default function Language({sideBarOpen}) {
    const {i18n} = useTranslation();
    const {t} = useTranslation();
    const classes = useStyles();

    const [anchorEl, setAnchorEl] = useState(null);
    const [currentFlag, setCurrentFlag] = useState();

    useEffect(() => {
        const language = localStorage.getItem('language');
        let flag = <img src={circleUSA} alt="autommate" style={{width: 24}}/>;
        if (language) {
            if (language.includes('tr')) {
                flag = <img src={circleTR} alt="autommate" style={{width: 24}}/>;
            }
        }
        setCurrentFlag(flag);
    }, [i18n.language])

    const showFlags = (event) => {
        return false;
        // temporarily suspended language selection
        // setAnchorEl(event.currentTarget);
    };

    const closeFlags = () => {
        setAnchorEl(null);
    };

    const selectFlag = (lang) => {
        if (lang === 'tr') {
            setCurrentFlag(<img src={circleTR} alt="autommate" style={{width: 24}}/>);
            changeLocalStorage('tr-TR');
        } else if (lang === 'en') {
            setCurrentFlag(<img src={circleUSA} alt="autommate" style={{width: 24}}/>);
            changeLocalStorage('en-EN');
        }
        closeFlags();
    }

    const changeLocalStorage = (language) => {
        i18n.changeLanguage(language).then(r => r);
    }

    return (
        sideBarOpen ? (
            <div className="link cover-list">
                <div
                    className={`list-has-subitem expanded hover-me`}>
                    <IconButton
                        style={{padding: 8}}
                        aria-controls="customized-menu"
                        aria-haspopup="true"
                        variant="contained"
                        color="primary"
                        onClick={showFlags}
                    >
                        <div
                            className={`language-flag-icon expanded`}>{currentFlag}</div>
                    </IconButton>
                    <StyledMenu
                        dense="true"
                        id="customized-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={closeFlags}
                        className={classes.langMenu}
                    >
                        {/*<StyledMenuItem className={classes.menu} onClick={() => selectFlag("tr")}>*/}
                        {/*    <img src={circleTR} alt="autommate"/>*/}
                        {/*    <ListItemText primary="Türkçe" className={classes.text}/>*/}
                        {/*</StyledMenuItem>*/}
                        <StyledMenuItem className={classes.menu} onClick={() => selectFlag("en")}>
                            <img src={circleUSA} alt="autommate"/>
                            <ListItemText primary="English" className={classes.text}/>
                        </StyledMenuItem>
                    </StyledMenu>
                    <Fade in={sideBarOpen} timeout={{enter: 500, exit: 100}}>
                        <div style={{width: "100%"}}
                             className={clsx({
                                 [classes.hide]: !sideBarOpen,
                             })}>
                                                  <span className="list-item-text language-text">
                                                    {t("CONTENT.SIDEBAR.LANGUAGE")}
                                                  </span>
                        </div>
                    </Fade>
                </div>
            </div>
        ) : (
            <div className="link cover-list-collapsed">
                <div
                    className={`list-has-subitem collapsed`}>
                    <IconButton
                        style={{padding: 8}}
                        aria-controls="customized-menu"
                        aria-haspopup="true"
                        variant="contained"
                        color="primary"
                        onClick={showFlags}
                    >
                        <div className="language-flag-icon">{currentFlag}</div>
                    </IconButton>
                    <StyledMenu
                        dense="true"
                        id="customized-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={closeFlags}
                        className={classes.langMenu}
                    >
                        <StyledMenuItem className={classes.menu} onClick={() => selectFlag("tr")}>
                            <img src={rectTR} alt="autommate"/>
                            <ListItemText primary="Türkçe" className={classes.text}/>
                        </StyledMenuItem>
                        <StyledMenuItem className={classes.menu} onClick={() => selectFlag("en")}>
                            <img src={rectUK} alt="autommate"/>
                            <ListItemText primary="English" className={classes.text}/>
                        </StyledMenuItem>
                    </StyledMenu>
                </div>
            </div>
        )
    );
}
